export const iconFontAwesomeUsersPeoplePersonPraying = (
	<i className="fa-solid fa-person-praying"></i>
);
